import React from 'react';
import { Container } from 'react-bootstrap';
import { Breadcrumb, Breadcrumbs } from 'react-rainbow-components';
import { Link } from "react-router-dom";

import "../../Portafolio/src/css/breadCrumbs.css";

export function myBreadCrumbsConvRaiz( ...obj:any ) {
  
  let raiz = "Gestión de Códigos Instiucionales";

  return (
    <Container className='breadcrumbs-area'>
      <div className="rainbow-p-around_large rainbow-m-bottom_xx-large rainbow-p-bottom_xx-large">
        <Breadcrumbs>
            <Breadcrumb label={ raiz } disabled />
        </Breadcrumbs>
      </div>
    </Container>
  )

};

export function myBreadCrumbsConvInte( ...obj:any ) {
  
  let raiz = "Gestión de Códigos Institucionals";

  return (
    <Container className='breadcrumbs-area'>
      <div className="rainbow-p-around_large rainbow-m-bottom_xx-large rainbow-p-bottom_xx-large">
        <Breadcrumbs>
          <Link to={"/home/operaciones/:id/ConveniosPanes"}>
            <Breadcrumb label={ raiz } href={ "/home/operaciones/:id/ConveniosPanes" } />
          </Link>
          <Breadcrumb label={ obj } disabled />
        </Breadcrumbs>
      </div>
    </Container>
  )

};

export function myBreadCrumbsConv3lv( ...obj:any ) {
  
  let raiz = "Gestión de Códigos Institucionales";
  let Child = "Crear Solicitud";

  return (
    <Container className='breadcrumbs-area'>
      <div className="rainbow-p-around_large rainbow-m-bottom_xx-large rainbow-p-bottom_xx-large">
        <Breadcrumbs>
          <Link to={"/home/operaciones/:id/ConveniosPanes"}>
            <Breadcrumb label={ raiz } href={ "/app/operaciones" } />
          </Link>
          <Breadcrumb />
          <Link to={"/home/operaciones/:id/CrearSolicitud"}>
            <Breadcrumb label={ Child } href={ "/home/operaciones/:id/CrearSolicitud"} />
          </Link>
          <Breadcrumb label={ obj } disabled />
        </Breadcrumbs>
      </div>
    </Container>
  )

};

//  ---- Para convenios creados ----

export function myBreadCrumbsConv4lv( ...obj:any ) {
  
  let raiz = "Gestión de Códigos Institucionales";
  let Child = "Crear Código";

  return (
    <Container className='breadcrumbs-area'>
      <div className="rainbow-p-around_large rainbow-m-bottom_xx-large rainbow-p-bottom_xx-large">
        <Breadcrumbs>
          <Link to={"/home/operaciones/:id/ConveniosPanes"}>
            <Breadcrumb label={ raiz } href={ "/app/operaciones" } />
          </Link>
          <Breadcrumb />
          <Link to={"/home/operaciones/:id/CrearConvenio"}>
            <Breadcrumb label={ Child } href={ "/home/operaciones/:id/CrearConvenio"} />
          </Link>
          <Breadcrumb label={ obj } disabled />
        </Breadcrumbs>
      </div>
    </Container>
  )

};